<template>
  <div class="barraInfo">
    <b-container fluid>
      <b-row align-h="between" class="alinhaBotaoVoltar">       
        <b-col cols="8">
              <p class="text-left textoVersao"> {{(`v${versao}`) }}</p>
        </b-col>
        <b-col v-if="breadcrumbState.botoesAcao.voltar" cols="4">
          <button
            id="btnVoltarCrud"
            class="btn btnPadrao btnVoltar"
            v-on:click.stop="() => clickEmit('VOLTAR')"
          >
            {{ $t("botao.voltar") }}
          </button>
        </b-col>       
      </b-row>
    </b-container>
    <div
      class="fitaOk"
      v-if="breadcrumbState.infoDadoSalvo != null ? true : false"
    >
      <b-row>
        <b-col>
          {{ $t("msg.salvo_com_sucesso") }}
          {{ breadcrumbState.infoDadoSalvo.descricao }}
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {versaoSoftware} from '../../config.js';
import { mapState } from "vuex";
import { EventBus } from "@/EventBus";

export default {
  data() {
		return {
      versao: versaoSoftware,
    }
  },
  methods: {
    clickEmit(evt) {
      EventBus.$emit(evt, true);
    },
  },

  computed: {
    ...mapState({ breadcrumbState: "breadCrumb" }),
  },
};
</script>

<style>
.fitaOk {
  position: absolute;
  top: 0px;
  height: 46px;
  background-color: #039803;
  width: 30px;
  font-size: 14px;
  left: 0px;
  box-shadow: 0px 0px 3px 0px #353535;
  padding-left: 30px;
  line-height: 44px;
  overflow: hidden;
  transition: width 0.2s linear;
  border-radius: 0px 5px 5px 0px;
}
.fitaOk:hover {
  width: -o-calc(100% - 20px);
  width: -webkit-calc(100% - 20px);
  width: -moz-calc(100% - 20px);
  width: calc(100% - 20px);
}
</style>